/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// component
import Content from 'material/embeds/content/content';



/* ========== ~~~~~~~~~~ EMBED : CONTENT : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { contentId }) => ({
    currentContentStatus: embedsState.embedManagementState.contentStatus['contents'][contentId],
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps
)(Content);
